import { render, staticRenderFns } from "./sidebar_preferences.vue.js?vue&type=template&id=7920d1cd&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_preferences.vue?vue&type=template&id=7920d1cd&vue3"
import script from "./sidebar_preferences.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_preferences.vue?vue&type=script&lang=js&vue3"
export * from "./sidebar_preferences.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_preferences.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports